// extracted by mini-css-extract-plugin
module.exports = {"chartTitle":"styles_chartTitle__31YWE"};